import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { NgxPermissionsService } from 'ngx-permissions';
import { delay, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import * as AuthActions from '@app/auth/store/actions/auth.action';
import * as fromMain from '@app/main/main.selectors';
import * as GuardActions from '@app/main/store/actions/guard-actions/guard.action';

import { ESTABLISHMENT_ID } from '../core/services/queryParameters.service';

@Injectable()
export class AppAuthGuard implements OnDestroy {
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    protected router: Router,
    protected activeRoute: ActivatedRoute,
    private permissionService: NgxPermissionsService,
    private mainStore: Store<fromMain.MainState>
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      const establishmentId: string = localStorage.getItem(ESTABLISHMENT_ID);

      if (establishmentId) {
        this.mainStore.dispatch(new GuardActions.SetEstablismentId({ establishmentId }));
      }

      if (state.url === '/main/acc_settings') {
        this.mainStore.dispatch(new GuardActions.OpenSettingsPage());
      } else {
        this.mainStore.dispatch(new GuardActions.CloseSettingsPage());
      }

      this.mainStore.pipe(delay(0), select(fromMain.getTermsConditionsState), takeUntil(this.unsubscribe$)).subscribe(terms => {
        if (terms && terms.hasBootstrapError) {
          this.mainStore.dispatch(new AuthActions.NavMenuLayoutHide());
        }

        if (terms && terms.establishments && terms.establishments.length > 0) {
          if (terms.establishmentDefault) {
            this.permissionService.loadPermissions(terms.establishmentDefault.roles);
          } else {
            this.permissionService.loadPermissions(terms.establishments[0].roles);
          }
        }
      });

      this.mainStore.pipe(delay(0), select(fromMain.getSelectedBusiness), takeUntil(this.unsubscribe$)).subscribe(dashboard => {
        if (!dashboard) {
          this.mainStore.dispatch(new AuthActions.NavMenuLayoutHide());
        } else {
          this.mainStore.dispatch(new AuthActions.NavMenuLayoutShow());
        }
      });

      resolve(true);
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
